module.exports = __webpack_public_path__ + "img/interest-1.ff81afb2.png";